import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/gif/genesis-loading.gif'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-center py-3" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "h-48 w-48",
    alt: "loading",
    src: _imports_0
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-300 font-semibold text-14px" }, " Permintaan QR Code Sedang Diproses ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogPaymentLayoutHeader = _resolveComponent("DialogPaymentLayoutHeader")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DialogPaymentLayoutHeader, {
      billType: _ctx.billType,
      textHeader: _ctx.billAmountAfterDiscount,
      textSubHeader: _ctx.billAmount
    }, null, 8, ["billType", "textHeader", "textSubHeader"]),
    _hoisted_1,
    _hoisted_2
  ], 64))
}